import type { Theme } from '@src/app/themes/theme';
import { Stack } from '@src/shared/ui/layout';
import { useContext } from 'react';
import { ToastContext } from './context';
import Toast from './Toast';

const StyleSheet = {
  container: (theme: Theme) => ({
    position: 'fixed',
    top: 15,
    left: theme.layout.sidebar.minWidth + 10,
    width: '700px',
    maxWidth: `calc(100% - ${theme.layout.sidebar.minWidth + 20}px)`,
    // Above side panels and dialogs, so their errors are not hidden under
    // the backdrop.
    zIndex: theme.zIndex.snackbar,
    [theme.breakpoints.up('md')]: {
      transform: 'translateX(-50%)',
      left: '50%',
    },
  }),
};

export default function ToastContainer() {
  const ctx = useContext(ToastContext);
  if (!ctx || ctx.toasts.length === 0) return null;

  return (
    <Stack spacing={0.5} sx={StyleSheet.container}>
      {ctx.toasts.map((toast) => (
        <Toast
          key={toast.id}
          title={toast.title}
          description={toast.description}
          severity={toast.severity}
          action={toast.action}
          dismissOnClick={toast.dismissOnClick}
          onClick={toast.onClick}
          icon={toast.icon}
          onDismiss={() => ctx.dismiss(toast.id)}
        />
      ))}
    </Stack>
  );
}
